import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { oneKlicks } from '../../SDK/oneclick';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import ImageShow from '../../Uitiles/ImageShow';

const EditHospitals = ({ closeModal, data, getHospitals }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [previewImage, setPreviewImage] = useState(data.profile_photo);

    const handleClose = () => {
        form.resetFields();
        setFileList([]);
        setPreviewImage(data.profile_photo);
        closeModal();
    };

    useEffect(() => {
        form.setFieldsValue({
            name: data.name,
            display_name: data.display_name,
            email: data.email,
            phone: data.phone,
            address: data.address,
            longitude: data.longitude,
            latitude: data.latitude,
            description: data.description,
            country: data.country
        });
    }, [data, form]);

    const handleSubmit = async (values) => {
        try {
            setLoading(true);

            // Upload profile photo if exists
            let profile_photo = previewImage;
            if (fileList.length > 0) {
                const file = fileList[0];
                const root = 'hospitals';
                const status = 'publish';
                const uploadResponse = await OneKlicksFileSDK.uploadFile(root, status, file);
                if (uploadResponse && uploadResponse.fileId) {
                    profile_photo = uploadResponse.fileId;
                }
            }

            // Update hospital in database
            const tableSchema = '';
            const tableName = 'users';
            const hospitalData = {
                ...values,
                profile_photo: profile_photo
            };

            const conditions = {
                id: data.id
            };

            const response = await oneKlicks.update(tableSchema, tableName, hospitalData, conditions);

            if (response && response.success) {
                message.success('Hospital updated successfully');
                form.resetFields();
                setFileList([]);
                closeModal();
                getHospitals();
            } else {
                message.error('Failed to update hospital');
            }
        } catch (error) {
            console.error('Error updating hospital:', error);
            message.error('Failed to update hospital');
        } finally {
            setLoading(false);
        }
    };

    const uploadProps = {
        onRemove: () => {
            setFileList([]);
            setPreviewImage(data.profile_photo);
        },
        beforeUpload: (file) => {
            setFileList([file]);
            setPreviewImage(URL.createObjectURL(file));
            return false;
        },
        fileList,
    };

    return (
        <Modal
            title="Edit Hospital"
            open={true}
            onCancel={handleClose}
            footer={null}
            width={800}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
            >
                <Form.Item
                    name="name"
                    label="Hospital Name"
                    rules={[{ required: true, message: 'Please enter hospital name' }]}
                >
                    <Input placeholder="Enter hospital name" />
                </Form.Item>

                <Form.Item
                    name="display_name"
                    label="Display Name"
                    rules={[{ required: true, message: 'Please enter display name' }]}
                >
                    <Input placeholder="Enter display name" />
                </Form.Item>

                <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                        { required: true, message: 'Please enter email' },
                        { type: 'email', message: 'Please enter a valid email' }
                    ]}
                >
                    <Input placeholder="Enter email" />
                </Form.Item>

                <Form.Item
                    name="phone"
                    label="Phone"
                    rules={[{ required: true, message: 'Please enter phone number' }]}
                >
                    <Input placeholder="Enter phone number" />
                </Form.Item>

                <Form.Item
                    name="address"
                    label="Address"
                    rules={[{ required: true, message: 'Please enter address' }]}
                >
                    <Input.TextArea rows={4} placeholder="Enter address" />
                </Form.Item>

                <Form.Item
                    name="longitude"
                    label="Longitude"
                >
                    <Input placeholder="Enter longitude" />
                </Form.Item>

                <Form.Item
                    name="latitude"
                    label="Latitude"
                >
                    <Input placeholder="Enter latitude" />
                </Form.Item>

                <Form.Item
                    name="description"
                    label="Description"
                >
                    <Input.TextArea rows={4} placeholder="Enter description" />
                </Form.Item>

                <Form.Item
                    name="country"
                    label="Country"
                    rules={[{ required: true, message: 'Please enter country' }]}
                >
                    <Input placeholder="Enter country" />
                </Form.Item>

                <Form.Item
                    label="Profile Photo"
                >
                    {previewImage && (
                        <div style={{ marginBottom: '10px' }}>
                            <ImageShow image={previewImage} width={100} height={100} style={{ objectFit: 'cover', borderRadius: '50%' }} />
                        </div>
                    )}
                    <Upload {...uploadProps} maxCount={1}>
                        <Button icon={<UploadOutlined />}>Upload New Photo</Button>
                    </Upload>
                </Form.Item>

                <Form.Item>
                    <div className="d-flex justify-content-end" style={{ gap: '10px' }}>
                        <Button onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button type="primary" htmlType="submit" loading={loading}>
                            Update Hospital
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EditHospitals; 
